import { render } from "./ElectricalMeasurements.vue?vue&type=template&id=3e7e8e56&scoped=true"
const script = {}

import "./ElectricalMeasurements.vue?vue&type=style&index=0&id=3e7e8e56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e7e8e56"

export default script